import styled from "styled-components";

export const ContainerGif = styled.div`
width: 100%;
height: 83vh;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
padding-top: 130px;
animation: fadein 300ms; 
@keyframes fadein {
    0% {
 opacity:0;
 }
 50%{
 opacity:0.5;
 }
 100% {
 opacity:1;
 }
}
`

export const LogoGif = styled.img`
width: 550px;
height: 420px;
border-radius: 20px;
`
export const A = styled.a`
text-decoration: none;
color: #89dddb;
`